module.exports = __webpack_public_path__ + "img/duckanddry.f49f2bf5.png";